"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _billConsigneeApplication = require("@/api/userCenter/billConsigneeApplication");
var _billButtons = _interopRequireDefault(require("@/views/userCenter/componens/billButtons.vue"));
var _vuex = require("vuex");
var _bookingHistoryJp = require("@/api/bookSpace/bookingHistoryJp");
var _bookingHilstoryJpButtons = _interopRequireDefault(require("@/views/booking/bookingSpace/components/bookingHilstoryJpButtons.vue"));
var _fileButtons = _interopRequireDefault(require("@/views/infoSearch/fileButtons.vue"));
var _vesselNameButtons = _interopRequireDefault(require("@/views/booking/bookingSpace/components/vesselNameButtons.vue"));
var _index3 = _interopRequireDefault(require("@/components/Transfer/index.vue"));
var _bookingHilstoryJpCopy = _interopRequireDefault(require("@/views/booking/bookingSpace/components/bookingHilstoryJpCopy.vue"));
var _bookingHilstoryJpVoyageNoAndLeg = _interopRequireDefault(require("@/views/booking/bookingSpace/components/bookingHilstoryJpVoyageNoAndLeg.vue"));
var _bookingHilstoryDateMonthEta = _interopRequireDefault(require("@/views/booking/bookingSpace/components/bookingHilstoryDateMonthEta.vue"));
var _bookingHilstoryDateMonthEtd = _interopRequireDefault(require("@/views/booking/bookingSpace/components/bookingHilstoryDateMonthEtd.vue"));
var _bookingHilstoryDateMonthEtaPol = _interopRequireDefault(require("@/views/booking/bookingSpace/components/bookingHilstoryDateMonthEtaPol.vue"));
var _bookingHistoryJpBkNo = _interopRequireDefault(require("@/views/booking/bookingSpace/components/bookingHistoryJpBkNo.vue"));
var _utils = require("@/utils");
var _date = require("@/utils/date");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "bookingHistoryJp",
  components: {
    BookingHistoryJpBkNo: _bookingHistoryJpBkNo.default,
    BookingHilstoryDateMonthEtaPol: _bookingHilstoryDateMonthEtaPol.default,
    BookingHilstoryDateMonthEtd: _bookingHilstoryDateMonthEtd.default,
    BookingHilstoryDateMonthEta: _bookingHilstoryDateMonthEta.default,
    BookingHilstoryJpVoyageNoAndLeg: _bookingHilstoryJpVoyageNoAndLeg.default,
    BookingHilstoryJpCopy: _bookingHilstoryJpCopy.default,
    Transfer: _index3.default,
    VesselNameButtons: _vesselNameButtons.default,
    FileButtons: _fileButtons.default,
    BookingHilstoryJpButtons: _bookingHilstoryJpButtons.default,
    Pagination: _index2.default,
    billButtons: _billButtons.default,
    filterColumn: _index.default
  },
  data: function data() {
    return {
      transferDialogVisible: false,
      sourceData: [],
      targetDataOne: [],
      value1: '',
      clientHeight: document.body.clientHeight - 320,
      dataTotal: 0,
      billRules: {
        accountNo: [{
          required: true,
          message: '请输入港口',
          trigger: 'blur'
        }],
        companyName: [{
          required: true,
          message: '请输入公司名称',
          trigger: 'blur'
        }],
        companyNameCn: [{
          required: true,
          message: '请输入公司名称(CN)',
          trigger: 'blur'
        }],
        usci: [{
          required: true,
          message: '请输入USCI',
          trigger: 'blur'
        }]
      },
      editDialog: false,
      dialogType: '',
      tableCostData: [],
      tableKey: 0,
      hotSettings: {
        dragCheck: true,
        height: 'auto',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      portOptions: [{
        value: 'CNSHA',
        label: 'CNSHA'
      }],
      billForm: {
        companyName: '',
        companyNameCn: '',
        usci: '',
        portCode: ''
      },
      issueTypList: [{
        value: '1',
        label: 'BILL OF LOADING'
      }, {
        value: '2',
        label: 'SEA WAYBILL'
      }],
      searchForm: {
        pol: '',
        pod: '',
        status: null,
        etdFrom: '',
        etdTo: '',
        etaFrom: '',
        etaTo: '',
        createdFrom: '',
        createdTo: '',
        bkNo: '',
        blNo: ''
      },
      totalMoney: 0,
      selectTableData: [],
      userInfo: {},
      selectionIds: [],
      showMainType: true,
      timeTypeRadio: '1',
      dataTime: [],
      isCancelSubmit: false,
      isCancelDel: false,
      bookingList: [],
      isActivated: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    var _this = this;
    this.$dictionary.get(['BOOKING_WEB_STATUS'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.bookingList = res.BOOKING_WEB_STATUS ? res.BOOKING_WEB_STATUS : [];
      _this.initData();
      _this.initDateSearchParam();
    });
  },
  activated: function activated() {
    if (this.isActivated) {
      this.searchFormData();
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.$nextTick(function () {
      _this2.resizeHotTable();
    });
  },
  watch: {
    selectTableData: {
      handler: function handler(newVal, oldVal) {
        if (this.selectTableData.length === 0) {
          this.totalMoney = 0;
        } else {
          this.totalMoney = this.selectTableData.reduce(function (total, item) {
            return total + parseInt(item.jpyAmount);
          }, 0);
        }
      },
      immediate: true
    }
  },
  methods: {
    initDateSearchParam: function initDateSearchParam() {
      this.timeTypeRadio = '1';
      var selectTimeDateForm = this.getNumberDate('day', -3);
      this.searchForm.etdFrom = selectTimeDateForm;
      this.searchForm.etaFrom = selectTimeDateForm;
      this.searchForm.createdFrom = selectTimeDateForm;
      var selectTimeDateTo = this.getNumberDate('day', 60);
      this.searchForm.etdTo = selectTimeDateTo;
      this.searchForm.etaTo = selectTimeDateTo;
      this.searchForm.createdTo = selectTimeDateTo;
      this.dataTime = [selectTimeDateForm, selectTimeDateTo];
    },
    changeTime: function changeTime(val) {
      if (val === '1') {
        this.dataTime = [this.searchForm.etdFrom, this.searchForm.etdTo];
      } else if (val === '2') {
        this.dataTime = [this.searchForm.etaFrom, this.searchForm.etaTo];
      } else if (val === '3') {
        this.dataTime = [this.searchForm.createdFrom, this.searchForm.createdTo];
      }
    },
    handleChangeTimeClear: function handleChangeTimeClear() {
      this.searchForm.etdFrom = '';
      this.searchForm.etdTo = '';
      this.searchForm.etaFrom = '';
      this.searchForm.etaTo = '';
      this.searchForm.createdFrom = '';
      this.searchForm.createdTo = '';
    },
    handleChangeTime: function handleChangeTime() {
      if (!this.dataTime) {
        this.handleChangeTimeClear();
        return;
      }
      if (this.timeTypeRadio === '1') {
        this.searchForm.etdFrom = (0, _date.dateFormat)('YYYY-MM-DD', this.dataTime[0]);
        this.searchForm.etdTo = (0, _date.dateFormat)('YYYY-MM-DD', this.dataTime[1]);
      } else if (this.timeTypeRadio === '2') {
        this.searchForm.etaFrom = (0, _date.dateFormat)('YYYY-MM-DD', this.dataTime[0]);
        this.searchForm.etaTo = (0, _date.dateFormat)('YYYY-MM-DD', this.dataTime[1]);
      } else if (this.timeTypeRadio === '3') {
        this.searchForm.createdFrom = (0, _date.dateFormat)('YYYY-MM-DD', this.dataTime[0]);
        this.searchForm.createdTo = (0, _date.dateFormat)('YYYY-MM-DD', this.dataTime[1]);
      }
    },
    hotTableSelect: function hotTableSelect(data) {
      this.selectTableData = this.$refs.hotTableCost.getSelections();
    },
    applyDownload: function applyDownload() {
      if (this.selectTableData.length === 0) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.applyDownloadWarning'),
          type: 'warning'
        });
        return;
      }
      if (this.selectTableData.length > 0) {
        if (this.selectTableData.some(function (item) {
          return item.jpyAmount === '0';
        })) {
          this.$message({
            message: this.$t('booking.bookingHistroyJp.applyDownloadWarning2') + this.selectTableData.filter(function (item) {
              return item.jpyAmount === '0';
            }).map(function (item) {
              return item.bkNo;
            }).toString() + this.$t('booking.bookingHistroyJp.applyDownloadWarning3'),
            dangerouslyUseHTMLString: true,
            type: 'warning'
          });
          return;
        }
        // for (let i = 0; i < this.selectTableData.length; i++) {
        //   if (!this.selectTableData[i].bkNo) {
        //     this.$message({
        //       message: this.$t('booking.bookingHistroyJp.applyDownloadWarning2'),
        //       dangerouslyUseHTMLString: true,
        //       type: 'warning'
        //     })
        //     return
        //   }
        // }
      }
      (0, _bookingHistoryJp.downLoadBLIssueForm)({
        id: this.selectTableData.map(function (item) {
          return item.bookingHeadWebId;
        }).toString()
      }).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res], {
          type: 'application/pdf'
        }));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', res.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    getNumberDate: function getNumberDate(type, number) {
      var nowdate = new Date();
      var y = '';
      var m = '';
      var d = '';
      var retrundate = '';
      var weekdate = '';
      switch (type) {
        case "day":
          //取number天前、后的时间
          nowdate.setTime(nowdate.getTime() + 24 * 3600 * 1000 * number);
          retrundate = (0, _date.dateFormat)('YYYY-MM-DD', nowdate);
          break;
        case "week":
          //取number周前、后的时间
          weekdate = new Date(nowdate + 7 * 24 * 3600 * 1000 * number);
          retrundate = (0, _date.dateFormat)('YYYY-MM-DD', weekdate);
          break;
        case "month":
          //取number月前、后的时间
          nowdate.setMonth(nowdate.getMonth() + number);
          retrundate = (0, _date.dateFormat)('YYYY-MM-DD', nowdate);
          break;
        case "year":
          //取number年前、后的时间
          nowdate.setFullYear(nowdate.getFullYear() + number);
          retrundate = (0, _date.dateFormat)('YYYY-MM-DD', nowdate);
          break;
        default:
          //取当前时间
          retrundate = (0, _date.dateFormat)('YYYY-MM-DD', nowdate);
      }
      return retrundate;
    },
    getNowFormatTime: function getNowFormatTime() {
      var nowDate = new Date();
      //补全0，并拼接
      return this.getNowFormatDay(nowDate);
    },
    getNowFormatDay: function getNowFormatDay(nowDate) {
      var char = "-";
      if (nowDate == null) {
        nowDate = new Date();
      }
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1
      var year = nowDate.getFullYear();
      //补全0，并拼接
      return year + char + this.completeDate(month) + char + this.completeDate(day);
    },
    completeDate: function completeDate(value) {
      return value < 10 ? "0" + value : value;
    },
    closeDialog: function closeDialog() {
      this.billForm = {
        companyName: '',
        companyNameCn: '',
        usci: '',
        portCode: ''
      };
    },
    handleToDetails: function handleToDetails(type, row) {
      var _this3 = this;
      var data = this.$refs.hotTableCost.getSelected();
      if (type == 'Submit') {
        this.$confirm(this.$t('booking.bookingHistroyJp.isSubmit'), '提示', {
          confirmButtonText: this.$t('userCenter.billConsigneeApplication.confirmButton'),
          cancelButtonText: this.$t('userCenter.billConsigneeApplication.cancelButton'),
          type: 'warning'
        }).then(function () {
          var params = [data.bookingHeadWebId];
          (0, _bookingHistoryJp.saveApplyBookingHeadWebs)(params).then(function (res) {
            _this3.searchFormData();
          }).catch(function (err) {});
        });
      } else if (type == 'Cancel') {
        this.$confirm(this.$t('booking.bookingHistroyJp.cancenConfirm'), 'Message', {
          confirmButtonText: this.$t('userCenter.billConsigneeApplication.confirmButton'),
          cancelButtonText: this.$t('userCenter.billConsigneeApplication.cancelButton'),
          type: 'warning'
        }).then(function () {
          _this3.cancelBooking(data.bookingHeadWebId);
        });
      } else {
        var _data = this.$refs.hotTableCost.getSelected();
        console.log('data', _data);
        console.log('data.etaPol', _data.etaPol);
        var arrayList = [];
        arrayList.push({
          vesselName: _data.vesselName,
          voyageNo: _data.voyageNo,
          voyageLeg: _data.voyageLeg,
          polEtaHidden: _data.etaPol,
          polEta: _data.etaPol,
          etd: _data.etd,
          eta: _data.eta,
          vesselCode: _data.vesselCode,
          serviceLineCode: _data.serviceLineCode,
          lineType: _data.lineType,
          tripNumber: _data.deliveryDocumentMethod,
          carrier: _data.carrier,
          polHidden: _data.pol,
          podHidden: _data.pod
        });
        if (type !== 'Cancel') {
          if (type === 'Copy') {
            this.$router.push({
              path: '/bookingSpace/bookingHistoryJpDetails',
              // voyageData:
              query: {
                type: type,
                id: _data.bookingHeadWebId,
                voyageData: []
              }
            });
          } else {
            this.$router.push({
              path: '/bookingSpace/bookingHistoryJpDetails',
              // voyageData:解决用对象传参导致的刷新显示不正确问题
              query: {
                type: type,
                id: _data.bookingHeadWebId,
                voyageData: JSON.stringify(arrayList)
              }
            });
          }
        }
      }
    },
    cancelBooking: function cancelBooking(id) {
      var _this4 = this;
      (0, _bookingHistoryJp.saveCancelBookingHeadWeb)(id).then(function (res) {
        _this4.searchFormData();
      }).catch(function (err) {});
    },
    resizeHotTable: function resizeHotTable() {
      // this.$refs.hotTableCost.resizeTo()
    },
    resetForm: function resetForm() {
      this.searchForm = {
        pol: '',
        pod: '',
        status: null,
        etaFrom: '',
        etaTo: '',
        etdFrom: '',
        etdTo: '',
        createdFrom: '',
        createdTo: '',
        bkNo: '',
        blNo: ''
      };
      this.initDateSearchParam();
    },
    exportFormData: function exportFormData() {
      var data = this.searchForm;
      data.currentPage = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      (0, _bookingHistoryJp.getExportHistory)(data).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res], {
          type: 'application/x-execl'
        }));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', res.fileName);
        // link.setAttribute('download', 'XXX.xlsx')
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    initData: function initData() {
      var _this5 = this;
      this.sourceData = [{
        data: 'status',
        title: this.$t('booking.bookingJapan.statusTable'),
        hasFilterStatus: true,
        filterList: this.bookingList
      }, {
        isBookingHisJpBtns: true,
        title: this.$t('booking.bookingJapan.actionTable')
      }, {
        isBookingHisJpBkNo: true,
        title: this.$t('booking.bookingJapan.BkgNoTable')
      }, {
        data: 'deliveryDocumentMethod',
        title: this.$t('booking.bookingJapan.billTypeTable'),
        hasFilter: true,
        filterList: this.issueTypList
      }, {
        data: 'blNo',
        title: this.$t('booking.bookingJapan.blNotable')
      }, {
        vessNameBtns: true,
        title: this.$t('booking.bookingJapan.vesselNameTable')
      }, {
        isVoyageNoAndLeg: true,
        title: this.$t('booking.bookingJapan.voyNoTable')
      }, {
        data: 'pol',
        title: this.$t('booking.bookingJapan.polTable')
      }, {
        isDateMonthEtaPol: true,
        title: this.$t('booking.bookingJapan.etaTable')
      }, {
        isDateMonthEtd: true,
        title: this.$t('booking.bookingJapan.etdTable')
      }, {
        data: 'pod',
        title: this.$t('booking.bookingJapan.podTable')
      }, {
        isDateMonthEta: true,
        title: this.$t('booking.bookingJapan.etaTable')
      }, {
        data: 'del',
        title: this.$t('booking.bookingJapan.deltable')
      }, {
        data: 'portAgentName',
        title: this.$t('booking.bookingJapan.portAgentNameTable')
      }, {
        data: 'terminalName',
        title: this.$t('booking.bookingJapan.TerminalNameTable')
      }, {
        data: 'updatedDtmLoc',
        title: this.$t('booking.bookingJapan.UpdateTimeTable')
      }];
      this.targetDataOne = [{
        data: 'bookingHeadWebId',
        title: this.$t('booking.bookingJapan.bookingHeadWebIdTable')
      }, {
        data: 'feeFlag',
        title: this.$t('booking.bookingJapan.feeFlagTable')
      }, {
        data: 'lockStatus',
        title: this.$t('booking.bookingJapan.lockStatusTable')
      }, {
        data: 'voyageLeg',
        title: this.$t('booking.bookingJapan.voyageLegTable')
      }, {
        data: 'vesselCode',
        title: this.$t('booking.bookingJapan.vesselCodeTable')
      }, {
        data: 'dbookingHeadId',
        title: this.$t('booking.bookingJapan.ccaNoTable')
      }, {
        data: 'publishToWeb',
        title: this.$t('booking.bookingJapan.freightMemoTable')
      }, {
        data: 'blFilesId',
        title: this.$t('booking.bookingJapan.tt3Table')
      }, {
        data: 'status',
        title: this.$t('booking.bookingJapan.submitTable')
      }, {
        data: 'status',
        title: this.$t('booking.bookingJapan.viewTable')
      }, {
        data: 'status',
        title: this.$t('booking.bookingJapan.changeTable')
      }, {
        data: 'status',
        title: this.$t('booking.bookingJapan.cancelTable')
      }, {
        isCopyItem: true,
        title: this.$t('booking.bookingJapan.copyTable')
      }];
      this.tableKey += 1;
      this.$nextTick(function () {
        _this5.searchFormData();
        _this5.isActivated = true;
      });
      this.$refs.transfer && this.$refs.transfer.initData(this.sourceData, this.targetDataOne);
    },
    handleSubimtSort: function handleSubimtSort(data) {
      this.transferDialogVisible = false;
      this.sourceData = data;
      this.tableKey += 1;
      this.searchFormData();
    },
    handleSortOpen: function handleSortOpen() {
      this.transferDialogVisible = true;
    },
    searchFormData: function searchFormData() {
      var _this6 = this;
      var data = (0, _utils.deepClone)(this.searchForm);
      data.currentPage = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      if (this.timeTypeRadio === '1') {
        data.etaFrom = '';
        data.etaTo = '';
        data.createdFrom = '';
        data.createdTo = '';
      } else if (this.timeTypeRadio === '2') {
        data.etdFrom = '';
        data.etdTo = '';
        data.createdFrom = '';
        data.createdTo = '';
      } else if (this.timeTypeRadio === '3') {
        data.etdFrom = '';
        data.etdTo = '';
        data.etaFrom = '';
        data.etaTo = '';
      }
      (0, _bookingHistoryJp.getQueryListHistory)(data).then(function (res) {
        _this6.tableCostData = res.data.records;
        _this6.listQuery.total = res.data.totalRecord;
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    saveFormClick: function saveFormClick() {
      var _this7 = this;
      this.$refs.billFormRef.validate(function (valid) {
        if (valid) {
          if (_this7.dialogType == 'add') {
            (0, _billConsigneeApplication.addWebBlConsigneeCertification)(_this7.billForm).then(function (res) {
              console.log('res', res);
              _this7.editDialog = false;
              _this7.searchFormData();
              _this7.$message({
                message: _this7.$t('userCenter.billConsigneeApplication.addSuccess'),
                type: 'success'
              });
            }).catch(function (err) {
              console.log('err', err);
              _this7.$message({
                message: err.errorMessages[0],
                type: 'error'
              });
            });
          } else if (_this7.dialogType == 'edit') {
            (0, _billConsigneeApplication.saveWebBlConsigneeCertification)(_this7.billForm).then(function (res) {
              console.log('res', res);
              _this7.editDialog = false;
              _this7.searchFormData();
              _this7.$message({
                message: _this7.$t('userCenter.billConsigneeApplication.editSuccess'),
                type: 'success'
              });
            }).catch(function (err) {
              console.log('err', err);
              _this7.$message({
                message: err.errorMessages[0],
                type: 'error'
              });
            });
          }
        } else {
          return false;
        }
      });
    },
    handlePath: function handlePath(row) {
      var data = this.$refs.hotTableCost.getSelected();
      var routeUrl = this.$router.resolve({
        path: '/topMenu/vesselMovementSearch',
        query: {
          vesselCode: data.vesselCode,
          vesselName: data.vesselName
        }
      });
      window.open(routeUrl.href, '_blank');
    }
  }
};